import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "account-select" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "account-select__account",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMenuAccounts && _ctx.openMenuAccounts(...args))),
      "data-test-id": "account-select__button"
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.account.name), 1),
      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon-nav-bullet_down" }, null, -1))
    ]),
    (_ctx.showAccounts)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: "account-select__accounts-list",
          onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseLeaveMenuAccounts && _ctx.mouseLeaveMenuAccounts(...args))),
          ref: "accountSelect",
          "data-test-id": "account-select__list"
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("p", null, [
            _createTextVNode(" Escolha uma conta "),
            _createElementVNode("i", { class: "icon-nav-bullet_up" })
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: account.action,
              "data-test-id": "account-select__option"
            }, _toDisplayString(account.label), 9, _hoisted_2))
          }), 128))
        ], 544))
      : _createCommentVNode("", true)
  ]))
}